<template>
  <div class="content_text_image" id="evaluation">
    <div class="title">Evaluation</div>
    <div class="news_topic">
      We welcome all researchers to evaluate their models on our NeMoBench. Our benchmark and model evaluation service will be made publicly available on requests for research
      purposes. Please contact us at lavilabcuhk@gmail.com.
      <br /><br />

      <!-- Please note that NeMoBench is distributed under the <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank" style="text-decoration: underline; color: #EFEFEF;">Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License</a>.  -->
      By using this dataset for evaluation, you agree to the terms and conditions of the license. You should acknowledge and understand that:
      <ul style="list-style-type: disc; padding-left: 20px; list-style-color: #ffffff">
        <li>- NeMoBench is for non-commercial academic use ONLY.</li>
        <li>- NeMoBench is for model evaluation ONLY.</li>
        <li>- NeMoBench MUST NOT be used for other purposes, including but not limited to model training or video editing.</li>
        <li>- You are required to use the dataset ethically and in compliance with all applicable laws and regulations.</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "EvaluationSection",
};
</script>

<style lang="scss" scoped>
// 定义断点变量
$mobile: 768px; // 移动端（≤768px）
$tablet: 1024px; // 平板（≤1024px）

.content_text_image {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px auto 0;
  padding: 0 15px;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    font-style: normal;
  }

  .news_topic {
    width: 100%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #efefef;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    padding: 20px;
    background: rgba(27, 34, 46, 0.3);
    border-radius: 10px;
  }
}

// 平板适配（≤1024px）
@media (min-width: $mobile + 1) and (max-width: $tablet) {
  .content_text_image {
    .title {
      font-size: 36px; // 平板端标题略缩小
      height: auto;
      margin-bottom: 25px;
    }

    .news_topic {
      max-width: 900px; // 限制平板端最大宽度
      font-size: 15px; // 文本略缩小
      line-height: 26px;
      padding: 18px;
    }
  }
}

// 移动端适配（≤768px）
@media (max-width: $mobile) {
  .content_text_image {
    .title {
      font-size: 26px; // 移动端标题进一步缩小
      height: auto; // 高度自适应
      margin-bottom: 20px;
    }

    .news_topic {
      font-size: 14px; // 移动端文本缩小
      line-height: 24px; // 行高优化
      padding: 15px; // 内边距减少
      border-radius: 8px; // 圆角略小，适配小屏幕
    }
  }
}
</style>
